import { useNavigate } from "react-router-dom";
import SectionLabel from "@/components/base/SectionLabel";
import { businessToolData } from "@/mocks/businessToolData";

export default function ServiceGuideSection() {
  const navigate = useNavigate();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14 reveal">
          <SectionLabel
            label={businessToolData.serviceGuide.label}
            className="mb-3"
          />
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            {businessToolData.serviceGuide.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-4xl mx-auto">
          {businessToolData.serviceGuide.services.map((svc, idx) => (
            <div
              key={idx}
              className={`reveal flex flex-col p-5 md:p-6 rounded-lg ${
                svc.isCurrent
                  ? "bg-primary-50/60 border-2 border-primary-300/60"
                  : "bg-background-50 border border-background-200/70"
              }`}
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              <div className="mb-3">
                <span
                  className={`inline-block text-[10px] font-bold tracking-wider uppercase px-2 py-0.5 rounded-full font-label ${
                    svc.isCurrent
                      ? "text-primary-600 bg-primary-100"
                      : "text-foreground-500 bg-secondary-100"
                  }`}
                >
                  {svc.type}
                </span>
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 font-heading">
                {svc.name}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3">
                {svc.tagline}
              </p>
              <ul className="space-y-1.5 flex-1 mb-4">
                {svc.points.map((p, i) => (
                  <li key={i} className="flex items-start gap-1.5 text-xs text-foreground-700">
                    <span className="w-1 h-1 rounded-full bg-primary-400 mt-1.5 flex-shrink-0" />
                    {p}
                  </li>
                ))}
              </ul>

              {svc.isCurrent ? (
                <span className="text-xs font-medium text-primary-600 mt-auto inline-flex items-center gap-1">
                  <i className="ri-check-double-line" />
                  現在のページ
                </span>
              ) : (
                <button
                  onClick={() => {
                    if (svc.href) navigate(svc.href);
                  }}
                  className="text-xs font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer inline-flex items-center gap-1 mt-auto whitespace-nowrap"
                >
                  詳しく見る
                  <i className="ri-arrow-right-line" />
                </button>
              )}
            </div>
          ))}
        </div>

        <p className="text-center text-xs text-foreground-500 mt-6 reveal">
          {businessToolData.serviceGuide.note}
        </p>
      </div>
    </section>
  );
}